import { required } from 'vuelidate/lib/validators'
import { guidValidator } from '@/components/validators'

export default {
  provide: function() {
    return {
      $vv: this.$v
    }
  },
  validations: {
    advancePaymentGroup: ['entity.vendorID', 'entity.payDate'],
    entity: {
      vendorID: {
        required,
        validGuid: guidValidator
      },
      payDate: {
        required
      }
    }
  }
}
